const formatDuration = (lengthInSeconds) => {
  const minutes = Math.floor(lengthInSeconds / 60);
  let seconds = lengthInSeconds % 60;
  seconds = seconds.toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
};

export default formatDuration;
